import React from 'react';
import { shape, string } from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'react-recompose';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { fetchAuthor } from './operations';
import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading';

import Section from '~/views/common/Section';
import Avatar from '~/views/common/Avatar';


const Container = styled(Link)`
    display: inline-flex;
`;

const Name = styled.div`
    font-weight: bold;
`;

const Email = styled.div`
    font-style: italic;
`;


export const Author = ({
    data: {
        id,
        name,
        logo_url,
        primary_email: {
            email,
        },
    },
}) => (
    <Section name="Author" >
        <Container to={`/users/${id}`}>
            <Avatar src={logo_url} />
            <div>
                <Name>{ name }</Name>
                <Email>{ email }</Email>
            </div>
        </Container>
    </Section>
);


Author.propTypes = {
    data: shape({
        id: string.isRequired,
        name: string.isRequired,
        logo_url: string.isRequired,
        primary_email: shape({
            email: string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default compose(
    setDisplayName('AuthorContainer'),
    setPropTypes({
        id: string.isRequired,
    }),
    withReduxDataLoading({
        name: 'fetchAuthor',
        operation: ({ id }) => fetchAuthor(id),
    }),
    withLoadingBranch,
)(Author);
